import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import './index.scss'
import ArrowLeft from './arrow-left.svg'
import SocialSharingLinks from 'components/SocialSharingLinks'
import { TweenMax, Power0, Power2 } from 'gsap'

class DrawerTitle extends Component {
  componentWillAppear (callback) {
    TweenMax.fromTo(this.el, 0.6, { autoAlpha: 0, y: '-100%' }, { autoAlpha: 1, y: '0%', ease: Power2.easeInOut, onComplete: callback })
  }

  componentWillEnter (callback) {
    TweenMax.fromTo(this.el, 0.6, { autoAlpha: 0, y: '-100%' }, { autoAlpha: 1, y: '0%', ease: Power2.easeInOut, onComplete: callback })
  }

  componentWillLeave (callback) {
    TweenMax.fromTo(this.el, 0.6, { autoAlpha: 1, y: '0%' }, { autoAlpha: 0, y: '-100%', ease: Power2.easeInOut, onComplete: callback })
  }

  render () {
    return (
      <div ref={el => { this.el = el }} className='content-drawer__title'>
        <div className='title'>
          {
            this.props.showBackButton &&
            <Link to='/news/' className='button'>
              <img src={ArrowLeft} alt='Back' />
            </Link>
          }
          {this.props.title}
          {
            this.props.showSocialLinks &&
            <SocialSharingLinks />
          }
        </div>
      </div>
    )
  }
}

DrawerTitle.propTypes = {
  title: PropTypes.string,
  showBackButton: PropTypes.bool,
  showSocialLinks: PropTypes.bool
}

export default DrawerTitle



// WEBPACK FOOTER //
// ./src/components/DrawerTitle/index.js